import React from 'react';
import {connect} from 'react-redux';
import UI from 'editor-ui-lib';
import Wix from 'Wix';
import { FormattedMessage } from 'react-intl';

import './support.scss';

class Support extends React.Component {

    constructor(props) {
        super(props);  

        this.renderTitle = this.renderTitle.bind(this);
        this.renderLink = this.renderLink.bind(this);
    }

    renderTitle(text) {
        return (
            <div>
                <hr className="divider-long"/>
                <UI.sectionDividerLabeled label={text}/>
                <hr className="divider-long"/>
            </div>
        )
    }

    renderLink(text, link) {
        return (
            <div className='div-link'>
                <a href={link}  target="_blank"><UI.symbol name='link'/></a>
                <UI.button
                    label={text}
                    className="btn-upgrade-link"
                    onClick={() => {window.open(link)}}>
                </UI.button>
            </div>
        )
    }

    render() {
        const locale =  Wix.Utils.getLocale()||'en';
        return (
            <div className='support-tab'>
                {this.renderTitle(<FormattedMessage id="settings.support.title"/>)}
                <div className='links'>
                   {this.renderLink(<FormattedMessage id="settings.support.link.setUp"/>, `https://support.wix.com/${locale}/article/adding-and-setting-up-the-google-drive-app-9434397`)}
                   <div style={{height: '6px'}}/>
                   {this.renderLink(<FormattedMessage id="settings.support.link.editing"/>, `https://support.wix.com/${locale}/article/allowing-or-blocking-the-editing-of-a-google-drive-file-or-folder`)}
                   <div style={{height: '6px'}}/>
                   {this.renderLink(<FormattedMessage id="settings.support.link.privacy"/>, `https://support.wix.com/${locale}/article/changing-google-drive-privacy-settings-for-files-or-folder-6081481`)}
                </div>
                {this.renderTitle(<FormattedMessage id="settings.support.reviewTitle"/>)}
                <div className='review'>
                    <div className='enjoying-Google-Driv'> 
                        <FormattedMessage id="settings.support.enjoy"/>
                    </div>
                    <UI.button
                        label={<FormattedMessage id="settings.support.button.addReview"/>}
                        className="btn-confirm-primary"
                        onClick={()=>Wix.Settings.openReviewInfo()}>
                    </UI.button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    dataPublic: state.dataPublicReducer.dataPublic,
});

export default connect(mapStateToProps)(Support);



// WEBPACK FOOTER //
// ./src/settings/Containers/gdUnitControlPanel/modules/support/support.js